import React from "react";
import { classNames } from "./utils/classNames";
import { IconOptions } from "./utils/iconOptions";
export var Steps = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "steps" }, children);
};
export var Step = function (_a) {
    var title = _a.title, active = _a.active, complete = _a.complete, glyph = _a.glyph;
    var iconType = glyph && IconOptions[glyph].type === "pro" ? "glyphicon-pro" : "glyphicon";
    var iconValue = glyph && IconOptions[glyph].value;
    return (React.createElement("div", { className: classNames("step", active ? "step--active" : "", complete ? "step--complete" : "") },
        React.createElement("div", { className: "step--title" },
            glyph && (React.createElement("span", { className: "icon ".concat(iconType, " ").concat(iconType, "-").concat(iconValue) })),
            React.createElement("div", { className: "step--circle" }),
            React.createElement("p", null, title))));
};
